import React, {useCallback, useEffect, useState} from 'react';
import {getFinancialYearList} from '../../services/it-depreciation.service';
import * as CryptoJS from "crypto-js";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

export default function GenerateITDepreciation() {
    const [financialYears, setFinancialYears] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const fetchFinancialYears = useCallback(async () => {
        try {
            setLoading(true);
            const EncryptData = CryptoJS.AES.encrypt(
                JSON.stringify({authToken: sessionStorage.getItem('LoggedInToken')}),
                process.env.REACT_APP_ENCRYPT_SECRET_KEY
            ).toString();

            const res = await getFinancialYearList({token: EncryptData});
            if (res?.data?.data?.length) {
                setFinancialYears(res.data.data);
            }
        } catch (err) {
            setErrMsg("Failed to load financial years");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchFinancialYears();
    }, [fetchFinancialYears]);

    const handleCardClick = (fyData) => {
        // Encrypting required data for the next page
        const financeData = {
            finance_year: fyData.financialYear,
            finance_year_name: fyData.financialYearName,
            back_url: window.location.pathname
        };

        const EncryptData = CryptoJS.AES.encrypt(
            JSON.stringify(financeData),
            process.env.REACT_APP_ENCRYPT_SECRET_KEY
        ).toString();
        window.location.href = "/it-master/generate-it-depreciation-cont?finance=" + EncryptData;
    };

    return (
        <div className='container-fluid py-4 bg-light' style={{minHeight: '100vh'}}>
            <div className="bg-white p-4 rounded shadow-sm mb-4 d-flex align-items-center gap-3">
                <h3 style={{
                    margin: 0,
                    fontSize: '1.45rem',
                    fontWeight: '700',
                    color: '#2c3e50',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                }}>
                    <i className="bi bi-calculator-fill" style={{color: '#007bff'}}></i>
                    Generate IT Depreciation
                </h3>
            </div>

            {errMsg && <div className="alert alert-danger shadow-sm">{errMsg}</div>}

            <div className="row">
                {financialYears.map((fy) => (
                    <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={fy.id}>
                        <div
                            className="card shadow-sm border-0"
                            style={{
                                cursor: 'pointer',
                                transition: '0.3s',
                                borderTop: '5px solid #1976d2'
                            }}
                            onClick={() => handleCardClick(fy)}
                            onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                            onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                        >
                            <div className="card-body text-center py-4">
                                <CalendarMonthIcon style={{fontSize: '3rem', color: '#1976d2', marginBottom: '10px'}}/>
                                <h4 className="fw-bold mb-1">{fy.financialYearName}</h4>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}